export default "__VITE_ASSET__YTcclEDU__"